import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import {
    Container,
} from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import DashboardTiles from './DashboardTiles';
import * as utilities from '../../utilities';
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';


class DashboardTileContainer extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.blankDashboardTile = {
            dashboardTileId: 0,
            name: '',
            description: '',
            configuration: '',
            types: '',
            module: '',
            order: 0,
            active: true,
            deleted: false,
            clients: []
        }
        this.state = {
            dashboardTiles: [],
            dashboardTileId: 0,
            editDashboardTile: { ...this.blankDashboardTile },
            newDashboardTile: { ...this.blankDashboardTile },
            isLoaded: false,
            unsavedChanges: false
        };
    }

    componentDidMount() {
        this.getDashboardTiles();
    }

    componentWillUnmount() {
        this.isUnmounted = true;
    }

    getDashboardTiles = () => {
        fetch('/api/dashboardTiles/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        dashboardTiles: results.data,
                        isLoaded: true
                    });
                } else {
                    utilities.addToast('Unable to load dashboard tiles.', 5, 'danger');
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditDashboardTile = (dashboardTileId) => {
        const dashboardTile = [...this.state.dashboardTiles].filter(item => item.DashboardTileId === dashboardTileId)[0];
        this.setState(() => {
            return {
                unsavedChanges: false,
                editDashboardTile: {
                    dashboardTileId: dashboardTile.DashboardTileId,
                    name: dashboardTile.Name,
                    description: dashboardTile.Description,
                    configuration: dashboardTile.Configuration,
                    types: dashboardTile.Types,
                    module: dashboardTile.Module,
                    order: dashboardTile.Order,
                    active: dashboardTile.Active,
                    deleted: dashboardTile.Deleted
                }
            }
        })
    }

    onDeleteDashboardTile = (dashboardTileId) => {
        fetch('/api/dashboardTiles/' + dashboardTileId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getDashboardTiles();
                    utilities.addToast('Dashboard tile deleted successfully.', 5, 'success')
                } else {
                    utilities.addToast('Unable to delete dashboard tile.', 5, 'danger')
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
            .finally(() => {
                this.setState({
                    unsavedChanges: false
                })
            })
    }

    onChangeDashboardTile = (e, type) => {
        e.persist();
        let thisDashboardTile = (type === 'edit') ? this.state.editDashboardTile : this.state.newDashboardTile;
        switch (e.target.name) {
            case "active":
                thisDashboardTile[e.target.name] = !thisDashboardTile[e.target.name];
                break;
            default:
                thisDashboardTile[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editDashboardTile: thisDashboardTile, unsavedChanges: true } : { newDashboardTile: thisDashboardTile, unsavedChanges: true };
        });
    }

    handleCancelDashboardTile = () => {
        this.setState({
            editDashboardTile: { ...this.blankDashboardTile },
            unsavedChanges: false
        })
    }

    handleAddDashboardTile = (e) => {
        let newOrder = Math.max(...this.state.dashboardTiles.map(i => i['order']), 0) + 10;
        fetch('/api/dashboardTiles/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newDashboardTile.name,
                description: this.state.newDashboardTile.description,
                configuration: this.state.newDashboardTile.configuration,
                types: this.state.newDashboardTile.types,
                module: this.state.newDashboardTile.module,
                order: newOrder,
                active: this.state.newDashboardTile.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newDashboardTile: { ...this.blankDashboardTile },
                        unsavedChanges: false
                    }, () => this.getDashboardTiles());
                    utilities.addToast('Dashboard tile added successfully.', 5, 'success')
                } else {
                    utilities.addToast('Unable to add dashboard tile.', 5, 'danger')
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditDashboardTile = () => {
        fetch('/api/dashboardTiles/' + this.state.editDashboardTile.dashboardTileId, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editDashboardTile.name,
                description: this.state.editDashboardTile.description,
                configuration: this.state.editDashboardTile.configuration,
                types: this.state.editDashboardTile.types,
                module: this.state.editDashboardTile.module,
                order: this.state.editDashboardTile.order,
                active: this.state.editDashboardTile.active,
                deleted: this.state.editDashboardTile.deleted,
                clients: this.state.editDashboardTile.clients
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editDashboardTile: { ...this.blankDashboardTile },
                        unsavedChanges: false
                    }, () => this.getDashboardTiles());
                    utilities.addToast('Dashboard tile updated successfully.', 5, 'success')
                } else {
                    utilities.addToast('Unable to update dashboard tile.', 5, 'danger')
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setDragTarget = (dashboardTileId) => {
        this.setState({
            dashboardTileId: dashboardTileId,
        })
    }

    reorder = () => {
        let dbDashboardTiles = [];
        let data = [...this.state.dashboardTiles];
        data = data.map((dashboardTile, dashboardTileIndex) => {
            if (dbDashboardTiles.findIndex(item => item.dashboardTileId === dashboardTile.DashboardTileId) === -1) dbDashboardTiles.push({ dashboardTileId: dashboardTile.DashboardTileId, order: (dashboardTileIndex + 1) * 10 })
            return { ...dashboardTile, order: (dashboardTileIndex + 1) * 10 }
        })
        this.setState({ dashboardTiles: data }, () => {
            fetch('/api/dashboardTiles-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                },
                body: JSON.stringify(
                    { dashboardTiles: dbDashboardTiles }
                )
            }, () => this.getDashboardTiles())
        });
    }

    render() {
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.dashboardTiles];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ dashboardTiles: data }, () => this.reorder());
            },
            nodeSelector: 'div.dashboardTileRow',
            handleSelector: 'span.dragIcon'
        };

        return (
            (this.state.isLoaded) ?
                <Container fluid>
                    <Prompt
                        when={this.state.unsavedChanges}
                        message="You have unsaved changes, are you sure you want to leave?"
                    />
                    <CollapseCard title="Dashboard Tiles Management" open={true}>
                        <DashboardTiles
                            {...this.props}
                            dashboardTiles={this.state.dashboardTiles}
                            newDashboardTile={this.state.newDashboardTile}
                            editDashboardTile={this.state.editDashboardTile}
                            dragProps={dragProps}
                            onChange={this.onChangeDashboardTile}
                            onEdit={this.onEditDashboardTile}
                            onDelete={this.onDeleteDashboardTile}
                            handleAdd={this.handleAddDashboardTile}
                            handleEdit={this.handleEditDashboardTile}
                            handleCancel={this.handleCancelDashboardTile}
                            setDragTarget={this.setDragTarget}
                        />
                    </CollapseCard>
                </Container>
                :
                <h3>Loading...</h3>
        );

    }
}

export default DashboardTileContainer;
